/**
 * O Perfil de Cliente Ideal: quais empresas-cliente tiram valor da plataforma, e o que
 * elas tem em comum.
 *
 * Espelho dos DTOs de `api/icp` no backend (`GET /v2/icp/overview`, `/v2/icp/companies` e
 * `/v2/icp/workforce`). Fracoes vem de 0 a 1 e o score de 0 a 100; os rotulos - faixa, porte,
 * os valores da persona - vem prontos da API, que e onde listas e textos mudam.
 *
 * Mora aqui, e nao em `domain`, porque so esta tela le estes tipos.
 */
/** As janelas que o servidor aceita. */
export const ICP_WINDOWS = [7, 15, 30];
/**
 * O porte de quem nao tem colaboradores contratados nem cadastrados.
 *
 * Aparece na comparacao por porte, mas nao vira opcao do filtro: o servidor nao filtra
 * por ele.
 */
export const NO_SIZE_BAND = 'SEM_PORTE';
/** As colunas do scorecard, na ordem do painel antigo. */
export const ICP_COLUMNS = [
    { field: 'name', label: 'Empresa' },
    { field: 'score', label: 'Score' },
    { field: 'band', label: 'Faixa' },
    { field: 'segment', label: 'Segmento' },
    { field: 'size', label: 'Porte' },
    { field: 'collaborators', label: 'Colaboradores' },
    { field: 'activation', label: 'Ativação' },
    { field: 'engagement', label: 'Engajamento' },
    { field: 'retention', label: 'Retenção' },
    { field: 'training', label: 'Treino' }
];
//# sourceMappingURL=icp.types.js.map